var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "#2D8CFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.6C5 8.03995 5 7.75992 5.10899 7.54601C5.20487 7.35785 5.35785 7.20487 5.54601 7.10899C5.75992 7 6.03995 7 6.6 7H13.4C13.9601 7 14.2401 7 14.454 7.10899C14.6422 7.20487 14.7951 7.35785 14.891 7.54601C15 7.75992 15 8.03995 15 8.6V15.4C15 15.9601 15 16.2401 14.891 16.454C14.7951 16.6422 14.6422 16.7951 14.454 16.891C14.2401 17 13.9601 17 13.4 17H6.6C6.03995 17 5.75992 17 5.54601 16.891C5.35785 16.7951 5.20487 16.6422 5.10899 16.454C5 16.2401 5 15.9601 5 15.4V8.6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10.5L18.6 8.55C18.8898 8.33265 19.0347 8.22397 19.1552 8.22482C19.2601 8.22556 19.3587 8.27444 19.4231 8.35726C19.4971 8.4525 19.4971 8.63363 19.4971 8.99588V15.0041C19.4971 15.3664 19.4971 15.5475 19.4231 15.6427C19.3587 15.7256 19.2601 15.7744 19.1552 15.7752C19.0347 15.776 18.8898 15.6674 18.6 15.45L16 13.5V10.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomLogo);
export default __webpack_public_path__ + "static/media/zoom-logo.6456076023f4067689cef1a644118a18.svg";
export { ForwardRef as ReactComponent };